import { useMemo } from "react"
import { useLocation, useNavigate } from "react-router-dom"
import { PanelMenu } from "primereact/panelmenu"
import { classNames } from "primereact/utils"
import useMainMenu from "../../hooks/useMainMenu"
import {
  buildPanelMenuModel,
  renderMaterialIconMenuItemTemplate,
} from "../../components/sidebars/components/helpers/menuBuilder"

import baseStyles from "../../styles/SidebarPanelMenuBase.module.css"
import styles from "../../styles/AdministrationMenu.module.css"

export default function AdministrationMenu({ className }) {
  const navigate = useNavigate()
  const location = useLocation()

  // Pull only the top-level sections that belong in the admin footer menu.
  const { menuItems, resolveMenuPath } = useMainMenu({
    includeLabels: [
      "Application Management",
      "Organization Management",
      "Enterprise Management",
    ],
  })

  const administrationItems = useMemo(() => {
    // Build admin model using shared PanelMenu mapper so behavior stays aligned across sidebars.
    return buildPanelMenuModel({
      items: menuItems,
      pathname: location.pathname,
      navigate,
      itemTemplate: renderMaterialIconMenuItemTemplate,
      // Resolve dynamic placeholders in route paths using current user/org context.
      resolvePath: resolveMenuPath,
      // Skip invalid payload rows that do not have display labels.
      includeItem: ({ item }) => Boolean(item?.label),
    })
  }, [location.pathname, menuItems, navigate, resolveMenuPath])

  if (!administrationItems.length) {
    return null
  }

  const menuClassName = classNames(
    baseStyles.menuRoot,
    styles.adminPanelMenu,
    className,
  )

  return (
    <PanelMenu className={menuClassName} model={administrationItems} multiple={false} />
  )
}
